module.exports = __webpack_public_path__ + "img/usa-liver-cancer-female.8d7dbcd8.png";